import React from 'react';
import { Container } from 'react-bootstrap';
import HeaderContainer from '../../containers/HeaderContainer';
import FooterContainer from '../../containers/FooterContainer';
import ErrorContainer from "../../containers/ErrorContainer";
const NonLoginErrorComponent = () => {
    return (
        <>
        <HeaderContainer className="App-header" />
        <Container className='mainContainer'>
            <div className="content" ontouchstart="">
               <ErrorContainer />
            </div>
        </Container>
        <FooterContainer />
        </>
        
    )
}
export default NonLoginErrorComponent;